<template>
<div>
  <div v-loading="loading" class="category-cascader">
    <el-cascader
      :width="width"
      :value="value"
      :key="keyValue"
      :options="categoryOptions || []"
      :props="categoryProps"
      :placeholder="classPlaceholder"
      clearable
      ref="cascader"
      :filterable="filterable"
      @change="(v) => $emit('change', v)"></el-cascader>
    <el-button @click="setMainCategoryClick" type="link" v-if="!hideSet">设置主营类目</el-button>
    <EditMainCategoryDialog ref="dialog" />
  </div>
  <ReuseLastCategory platform="base" @updateIds="changeIds" v-if="!hideCache && !value.length"/>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import {getMainCategoryList, getCategoryListByCidAndLv} from '@/servers/prod/center'
import EditMainCategoryDialog from '../dialogs/EditMainCategoryDialog.vue'
import ReuseLastCategory from "./PlatformCategoryInput/ReuseLastCategory.vue";

// 类目级联选择器
export default {
  model: {
    prop: 'arr',
    event: 'change'
  },
  components: {
    EditMainCategoryDialog,
    ReuseLastCategory
  },
  props: {
    arr: {
      type: Array,
      default() {
        return []
      }
    },
    hideCache: {
      type: Boolean,
      default: false
    },
    hideSet:{
      type: Boolean,
      default: false
    },
    width:{
      type: String,
      default:'300px'
    },
    classPlaceholder:{
      type: String,
      default:'请选择'
    },
    platformCascaderCategory:{
      type: Array
    },
    filterable:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoryProps: {
        value: 'cid',
        label: 'name',
        // lazy: true,
        // lazyLoad: this.lazyLoad
      },
      mainCategoryList: [],
      initOptionsLoading: false,
      keyValue:0
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    value() {
      return this.arr.map(Number)
    },
    categoryOptions() {
      let platformCascaderCategory = this.platformCascaderCategory;
      return platformCascaderCategory ? platformCascaderCategory : this.$store.getters.baseCascaderCategory
    },
    loading() {
      return this.initOptionsLoading
    }
  },
  watch: {
    value: {
      handler(v) {
        if (v.length) {
          this.$nextTick(() => {
            this.cacheIds(v);
          })
        }
      },
      deep: true,
      immediate: true,
    },
    categoryOptions(){
      this.keyValue++;
    }
    // level1(v) {
    //   if (v) {
    //     v.forEach(element => {
    //       if (this.categoryOptions.findIndex(item => item.cid === element.value) === -1) {
    //         this.categoryOptions.push({cid: element.value, leaf: element.leaf, name: element.label})
    //       }
    //     });
    //     // 第一层出来后加载选项
    //     this.initOptions(v.map(element => ({cid: element.value, leaf: element.leaf, name: element.label})))
    //   }
    // }
  },
  methods: {
    cacheIds(v) {
      if (!this.$refs.cascader) return;
      const nodes = this.$refs.cascader.getCheckedNodes();
      let names = []
      if (nodes && nodes[0]) {
        names = nodes[0].pathLabels;
      }
      if (names && names.length) {
        const staffId = this.userInfo.staffId;
        let ids = localStorage.getItem(staffId);
        if (ids) {
          try {
            ids = JSON.parse(ids);
          } catch(e) {
            console.error(e);
          }
        } else {
          ids = {};
        }
        if (!ids['base']) ids['base'] = {};
        ids['base'].ids = v;
        ids['base'].names = names
        localStorage.setItem(staffId, JSON.stringify(ids));
      }
    },
    changeIds(v) {
      this.$emit('change', v.ids);
    },
    // 初始化选项
    async initOptions(level1) {
      this.initOptionsLoading = true
      try {
        let options = await this.loadOptions(level1, true)
        this.categoryOptions = options
      } catch (error) {
        
      } finally {
        this.initOptionsLoading = false
      } 
    },
    // 根据value值递归加载选项
    async loadOptions(category, isTop = false) {
      let array = [];
      for (let i = 0; i < category.length; i++) {
        if (
          (isTop || category[i].leaf === 0) &&
          this.value.includes(category[i].cid)
          
        ) {
          let res = await getCategoryListByCidAndLv(category[i].cid, isTop ? 2 : category[i].level+1);
          if (res) {
            category[i].children = await this.loadOptions(res);
          }
        }
        array.push(category[i]);
      }
      return array;
    },
    async lazyLoad(node, resolve) {
      if (node.root) {
        resolve([])
      } else if (node.children && node.children.length) {
        resolve(node.children.map(item => ({...item, cid: item.value, name: item.label})))
      } else {
        const res = await getCategoryListByCidAndLv(node.value, node?.level)
        resolve(res ? res : [])
      }
    },
    setMainCategoryClick() {
      this.$refs.dialog.method_open(this.mainCategoryList, (mainList) => {
        this.$store.dispatch("getCategory")
        this.getMainCategoryList()
      })
    },
    async getMainCategoryList() {
      try {
        let res = await getMainCategoryList()
        if (res) {
          this.mainCategoryList = res
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  created() {
    // 获取已设置主营类目
    this.getMainCategoryList()
    // 获取设置主营类目列表
    this.$store.dispatch("getBaseCategoryTopAnd1")
  }
}
</script>

<style>

</style>